import Answer from '@/models/Answer.js'

class Question {
  id = null

  question = ''

  abstention = false

  randomize_options = false

  event_id = null

  created_at = null

  updated_at = null

  answers = [new Answer(), new Answer()]

  min_choices = 1

  max_choices = 1

  multiple_choices_enabled = false

  started_at = null

  stopped_at = null

  voters = null

  order = null

  quorum_value = null

  anonymous = null

  constructor(options = {}) {
    Object.assign(this, options)
  }

  addBlankAnswer() {
    this.answers.push(new Answer())
  }

  removeAnswer(key) {
    this.answers.splice(key, 1)
  }

  // let question = (new Question).fill({ question: "whatever" });
  fill(options) {
    return Object.assign(this, options)
  }

  getStatus() {
    if (this.stopped_at !== null) {
      return 'stopped'
    }

    if (this.started_at !== null) {
      return 'started'
    }

    return 'draft'
  }

  isActive() {
    return this.started_at !== null && this.stopped_at === null
  }

  isFinished() {
    return this.started_at !== null && this.stopped_at !== null
  }

  isDraft() {
    return this.started_at === null && this.stopped_at === null
  }
}

export default Question
